module.exports = __webpack_public_path__ + "img/sponsor-boysgirls-logo.492c82f1.jpg";